"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = {
  framerate: 24,
  images: [require('./sideSprite.png')],
  frames: [[344, 1107, 338, 1082, 0, -996, -134], [2, 2193, 338, 1082, 0, -996, -134], [3422, 1107, 338, 1082, 0, -996, -134], [3080, 1107, 338, 1082, 0, -996, -134], [2738, 1107, 338, 1082, 0, -996, -134], [2396, 1107, 338, 1082, 0, -996, -134], [2054, 1107, 338, 1082, 0, -996, -134], [1712, 1107, 338, 1082, 0, -996, -134], [1370, 1107, 338, 1082, 0, -996, -134], [1028, 1107, 338, 1082, 0, -996, -134], [686, 1107, 338, 1082, 0, -996, -134], [344, 2193, 338, 1082, 0, -996, -134], [2, 1107, 338, 1082, 0, -996, -134], [3478, 2, 338, 1082, 0, -996, -134], [3136, 2, 338, 1082, 0, -996, -134], [2794, 2, 338, 1082, 0, -996, -134], [2452, 2, 338, 1082, 0, -996, -134], [2110, 2, 338, 1082, 0, -996, -134], [1734, 2, 372, 1087, 0, -998, -129], [909, 2, 446, 1094, 0, -973, -122], [2, 2, 453, 1101, 0, -968, -116], [459, 2, 446, 1094, 0, -973, -122], [1359, 2, 371, 1087, 0, -999, -129]],
  animations: {
    'stand idle': {
      frames: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 2, 2, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      speed: 1
    },
    'confident idle': {
      frames: [8, 8, 8, 8, 8, 8, 8, 8, 8, 16, 16, 17, 17, 16, 16, 8, 8, 18, 18, 18, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 22, 22, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
      speed: 1
    },
    'talk loop': {
      frames: [3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 7, 8, 8, 8, 9, 9, 9, 5, 5, 5, 10, 10, 10, 3, 3, 3, 9, 9, 9, 6, 6, 6, 5, 5, 5, 11, 11, 12, 13, 14, 14, 3, 3, 3, 8, 8, 8, 15, 15, 15, 3, 3, 3, 5, 5, 6, 6, 6, 10, 10, 10, 4, 4, 4, 7, 7, 7, 5, 5, 5, 3, 3, 3, 8, 8, 8],
      speed: 1
    }
  }
};
exports["default"] = _default;